import React, { FC, useEffect } from 'react';
import { GoBackBtn } from '../header/GoBackBtn';
import { PageTitle } from '../../layout/core';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { useMerchants } from '../../store/merchnts/merchants-context';
import {
	fetchPartnerDetails,
	fetchPartnersFees,
	setPartnerDetailsDefault,
} from '../../store/merchnts/actions/partners';
import { PartnerDetailsLayout } from './PartnerDetailsLayout';
import { OrderStatus } from '../orders/OrderStatus';
import { PARTNER_NAVIGATION } from '../../constants/new-partner/partner-navigation';
import { usePaymentContext } from '../../store/payments/payments-context';
import { fetchPartnerBankDetails, setToDefaultPartnerBankDetails } from '../../store/payments/actions/partners';
import { useLocation } from 'react-router';

interface Props {
	children: React.ReactElement;
}
export const PartnerDetails: FC<Props> = ({ children }) => {
	const { t } = useTranslation();
	const { partnerId, clientId } = useParams();
	const { state } = useLocation();

	const { merchantState: { partnerDetailsData }, dispatch } = useMerchants();
	const { dispatch: paymentDispatch } = usePaymentContext();

	useEffect(() => {
		void fetchPartnerDetails({ dispatch, pid: partnerId });
	}, []);

	useEffect(() => {
		void fetchPartnersFees(dispatch, partnerId);
	}, []);

	useEffect(() => {
		if (!partnerDetailsData?.financialAccountId) return;
		void fetchPartnerBankDetails({
			dispatch: paymentDispatch,
			financialAccountId: partnerDetailsData?.financialAccountId
		});
	}, [partnerDetailsData?.financialAccountId]);

	useEffect(() => {
		return () => {
			setToDefaultPartnerBankDetails(paymentDispatch);
			setPartnerDetailsDefault(dispatch);
		};
	}, []);

	const backUrl = clientId
		? `/partners/${partnerId}/${PARTNER_NAVIGATION.API_KEYS}`
		: `/partners${state?.search || ''}`;

	return (
		<>
			<PageTitle
				breadcrumbs={[
					{
						title: t('MENU.PARTNERS'),
						path: '/partners',
						isSeparator: false,
						isActive: false
					},
					{
						title: '',
						path: '',
						isSeparator: true,
						isActive: false
					}
				]}
			>
				{partnerId}
			</PageTitle>
			<div className="d-flex align-items-center justify-content-between mb-5">
				<GoBackBtn path={backUrl} />
				<div className="d-flex align-items-center">
					{
						partnerDetailsData?.mainContact?.userCreated !== null && (
							<OrderStatus
								statusName={partnerDetailsData?.mainContact?.userCreated ? 'Active' : 'Pending'}
								title="User Status"
								additionalClasses={!partnerDetailsData?.mainContact?.userCreated && 'text-black'}
							/>
						)
					}
					{
						partnerDetailsData?.statusName && (
							<OrderStatus
								statusName={partnerDetailsData?.statusName}
								title="Partner Status"
								// additionalClasses={!partnerData?.contact?.userCreated && 'text-black'}
							/>
						)
					}
				</div>
			</div>
			<PartnerDetailsLayout>
				{children}
			</PartnerDetailsLayout>
		</>
	);
};